import React from "react";

import Styles from "./ContactUsCard.styles";
import { ContactUsCardProps as Props } from "./ContactUsCard.types";

const ContactUsCard: React.FC<Props> = props => {
  const { serviceName, serviceValue, btnText, link } = props;

  return (
    <Styles className="ContactUsCard">
      <div className="ContactUsCard__info">
        <p className="ContactUsCard__title">{serviceName}</p>
        <p className="ContactUsCard__subTitle">{serviceValue}</p>
      </div>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="ContactUsCard__link"
      >
        {btnText}
      </a>
    </Styles>
  );
};

ContactUsCard.defaultProps = {};

export default ContactUsCard;
